import React, { memo, useState } from "react";
import { Form, Tooltip, OverlayTrigger, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import AdminActionsPopupNew from "../../admin-actions-popup/AdminActionsPopupNew";
import TasksModalNew from "../template-tasks-modal/template-tasks-modal-new";
import {
  addSelectedTemplate,
  deleteSelectedTemplate,
} from "../../../../../redux/templates/template-actions";
import { selectSelectedTemplates } from "../../../../../redux/templates/template-selector";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import "./templates-table.styles.scss";

const TemplateRowNew = ({ data, privileges }) => {
  const [showAdminActionsPopup, setShowAdminActionsPopup] = useState(false);
  const [showTasksModal, setShowTasksModal] = useState(false);

  const history = useHistory();
  const dispatch = useDispatch();
  const selectedRows = useSelector(selectSelectedTemplates);

  const onEdit = () => {
    if (!privileges.Templates.Edit === false) {
      history.push({
        pathname: `/admin/templates/edit/${data.Id}`,
        state: { createPermission: privileges.Templates.Add },
      });
    }
  };

  const onSelect = (e) => {
    if (e.target.checked) {
      dispatch(addSelectedTemplate(data.Id));
    } else {
      dispatch(deleteSelectedTemplate(data.Id));
    }
  };

  return (
    <tr className="template-row-1">
      <td className="th-checkbox-col">
        {data && (
          <Form.Check
            type={"checkbox"}
            disabled={!privileges.Templates.Delete}
            onClick={(e) => {
              onSelect(e);
            }}
            checked={selectedRows.includes(data.Id)}
          />
        )}
      </td>
      <td className="data-text template-names">{data.ProjectType}</td>
      <td className="data-text">
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 50 }}
          overlay={
            <Tooltip id="tooltip-1" className="description-popup">
              {data.Description ? data.Description : ""}
            </Tooltip>
          }
        >
          <Button className="description-text">
            <span className="template-description">
              {data.Description ? data.Description : ""}
            </span>
          </Button>
        </OverlayTrigger>
      </td>
      <td className="data-text template-duration">
        <span className="duration-description">{data.Days}</span>
      </td>

      <td className="template-access">
        {data.IsVisible ? (
          <div className="access-description">Public</div>
        ) : (
          <div className="access-description">Private</div>
        )}
      </td>
      <td className="admin-row-action-buttons template-actions">
        <div
          className={"btn-icon1 template-action-icon1"}
          onClick={() => setShowTasksModal(true)}
          title="Tasks"
        />

        <Button
          className={`btn-icon1 btn-icon-edit ${
            !privileges.Templates.Edit === false
              ? "edit-icon1"
              : "edit-icon1-disabled"
          }`}
          disabled={!privileges.Templates.Edit}
          onClick={() => onEdit()}
          title="Edit"
        />
      </td>

      {showAdminActionsPopup && (
        <AdminActionsPopupNew
          type={"template"}
          name={data.ProjectType}
          selectedIDs={[data.Id]}
          showAdminActionsPopup={showAdminActionsPopup}
          setShowAdminActionsPopup={setShowAdminActionsPopup}
        />
      )}
      {showTasksModal && (
        <TasksModalNew
          show={showTasksModal}
          onHide={() => setShowTasksModal(false)}
          templateName={data.ProjectType}
          templateID={data.Id}
        />
     )}
    </tr>
  );
};

TemplateRowNew.propTypes = {
  data: PropTypes.object.isRequired,
  privileges: PropTypes.object.isRequired,
};
export default memo(TemplateRowNew);
